<template>
  <div class="w100">
    <el-dialog :visible.sync="isShow" :close-on-click-modal="!loading" :close-on-press-escape="false" :show-close="!loading" width="1000px">
      <span class="font-16" slot="title">未来7天车辆申请信息</span>
      <div class="w100">
        <div class="w100 pb20 flex-box al-c">
          已准：<span class="type-color mr20" :style="showCarComputed(showCar.YZ, '#33d223')"></span>
          待批：<span class="type-color mr20" :style="showCarComputed(showCar.DP, '#409eff')"></span>
          <!-- 已准：<span class="type-color mr20 cu-p" @click="showCar.YZ = !showCar.YZ" :style="showCarComputed(showCar.YZ, '#33d223')"></span> -->
          <!-- 未准：<span class="type-color mr20 cu-p" @click="showCar.WZ = !showCar.WZ" :style="showCarComputed(showCar.WZ, '#de3939')"></span> -->
          <!-- 待批：<span class="type-color mr20 cu-p" @click="showCar.DP = !showCar.DP" :style="showCarComputed(showCar.DP, '#409eff')"></span> -->
        </div>
        <el-table class="w100" :data="computeList.list" stripe border height="600" :cell-style="{ 'padding-top': 0, 'padding-bottom': 0 }">
          <el-table-column label="日期" resizable align="center" width="120" fixed>
            <template slot-scope="scope">
              <p>{{ scope.row.date | filterDate('yyyy-MM-dd') }}<br>（{{ scope.row.date | getWeek }}）</p>
            </template>
          </el-table-column>
          <el-table-column v-for="(item, index) in computeList.labelData" :key="index" :label="item.label" resizable align="center" min-width="120">
            <template slot-scope="scope">
              <div class="po-r w100 car-date">
                <section v-for="(val, key) in scope.row[item.key]" :key="key">
                  <el-popover v-if="val.status != '空闲'" v-show="(showCar.YZ && val.status == '已准') || (showCar.DP && val.status == '待批')" placement="top-start" :title="val.user" width="200" trigger="hover">
                    <p class="">{{ scope.row.date | filterDate('yyyy-MM-dd') }} {{ val.timeZone }}</p>
                    <div class="po-a flex-box al-c ju-c white car-com" slot="reference" :style="getHeight(val)">{{ val.timeZone }}</div>
                  </el-popover>
                </section>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "CarSevenDay",
  components: {},
  data() {
    return {

      isShow: false,
      loading: false,
      list: [],
      showCar: {
        YZ: true,
        WZ: true,
        DP: true
      }
    };
  },
  created() {},
  computed: {
    computeList() {
      let obj = {
        list: [],
        labelData: []
      };
      const today = new Date();
      for (const i in this.list) {
        let car = {
          label: this.list[i].carNo,
          key: "car" + i
        };
        obj.labelData.push(car);
      }
      for (const i in obj.labelData) {
        for (const k in this.list[i].carAppointList) {
          if (!obj.list[k]) {
            obj.list.push({});
          }
          if (!obj.list[k].date) {
            obj.list[k].date = today.getTime() + 86400000 * k;
          }
          let keyName = obj.labelData[i].key;
          obj.list[k][keyName] = this.list[i].carAppointList[k].detailList;
        }
      }
      // console.log(obj);
      return obj;
    }
  },
  mounted() {},
  methods: {
    showList() {
      this.isShow = true;
      if (this.list.length) {
        return;
      }
      this.loading = true;
      this.$http
        .post("car/query/appointRecord")
        .then(({ data }) => {
          // console.log(data.resData);
          if (data.resCode == 0 && data.resStatus == 0) {
            this.list = data.resData;
          } else {
            this.$message({
              message: data.resMsg,
              type: "error"
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.$message({
            message: "网络请求错误，请检查网络",
            type: "error"
          });
          this.loading = false;
        });
    },
    getHeight(obj) {
      const start =
        new Date(obj.startTimeStamp).getHours() * 3600 +
        new Date(obj.startTimeStamp).getMinutes() * 60;
      const end =
        new Date(obj.endTimeStamp).getHours() * 3600 +
        new Date(obj.endTimeStamp).getMinutes() * 60;
      let height = 0,
        top = 0,
        bg = "";
      if (obj.status == "待批") {
        bg = "#409eff";
      } else if (obj.status == "已准") {
        bg = "#33d223";
      } else if (obj.status == "未准") {
        bg = "#de3939";
      }
      height = (((end - start) / 86400) * 100).toFixed(2);
      top = ((start / 86400) * 100).toFixed(2);
      return {
        height: height + "%",
        top: top + "%",
        background: bg
      };
    },
    showCarComputed(show, color) {
      if (show) {
        return {
          background: color
        };
      } else {
        return {
          background: "#efefef"
        };
      }
    }
  }
};
</script>

<style scoped>
.type-color {
  display: inline-block;
  width: 1.2em;
  height: 1.2em;
  border-radius: 4px;
}

.car-date {
  height: 100px;
}

.car-com {
  width: calc(100% + 20px);
  left: -10px;
}
</style>
